export default __webpack_public_path__ + "images/insta.28a10b20.svg";